import { createContainer } from "@vanilla-extract/css";

export const newsContainer = createContainer();
export const NEWS_CONTAINER_BREAKPOINTS = {
  0: "500px",
  1: "600px",
  2: "945px",
};
